import { gql } from '@apollo/client';

export const SIGN_UP_MUTATION = gql`
  mutation SignUpMutation($email: String!, $password: String!) {
    signUp(email: $email, password: $password) {
      ... on SignUpSuccess {
        result
      }
      ... on ValidationError {
        errors {
          error
          path
        }
      }
    }
  }
`;
